export var iconOnlySpacing = {
  '&&': {
    padding: '0px',
    /**
        Increased specificity here because css for .hyperlink-open-link defined in
        packages/editor/editor-core/src/ui/ContentStyles/index.tsx file
        overrides padding left-right 2px with 4px.
      */
    '&&[href]': {
      padding: '0 2px'
    }
  },
  '& > span': {
    margin: '0px'
  }
};
var getStyles = function getStyles(property, _ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'default' : _ref$state,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'light' : _ref$mode;
  if (!property[appearance] || !property[appearance][state]) {
    return 'initial';
  }
  return property[appearance][state][mode];
};
var background = {
  danger: {
    default: {
      light: 'inherit',
      dark: 'inherit'
    },
    hover: {
      light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
      dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    active: {
      light: "var(--ds-background-neutral-pressed, #091E424F)",
      dark: "var(--ds-background-neutral-pressed, #091E424F)"
    }
  }
};
var color = {
  danger: {
    default: {
      light: "var(--ds-icon, #44546F)",
      dark: "var(--ds-icon, #44546F)"
    },
    hover: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    },
    active: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    }
  }
};
export var getButtonStyles = function getButtonStyles(props) {
  return {
    background: getStyles(background, props),
    color: getStyles(color, props)
  };
};